/**
 * 셀프호스팅 Pretendard JP 폰트 (public/fonts)
 * woff2 는 immutable 1년 — 교체 시 반드시 버전 디렉토리를 올릴 것
 */
const JA_FONT_BASE_URL = '/fonts/pretendard-jp/v1.3.9';

/**
 * CSS 는 next.config.js 에서 1일 캐시로 따로 잡는다.
 * `.v2` 는 1회성 캐시 탈출 — 기존 방문자가 옛 URL 을 immutable 로 들고 있어(RFC 8246)
 * 헤더 변경도 CDN invalidation 도 닿지 않는다. 이후로는 1일이라 또 올릴 필요 없다.
 *
 * 구 경로 `pretendard-jp-variable.css` 는 **호환용 사본**으로 남겨 뒀다 — 배포 직전에
 * 열린 탭의 옛 번들이 그 URL 을 prefetch 하기 때문이다. 다음 배포 이후 삭제해도 된다.
 */
export const JA_FONT_CSS_URL = `${JA_FONT_BASE_URL}/pretendard-jp-variable.v2.css`;

// 히라가나/가타카나/일본어 구두점을 담은 서브셋 — ja 페이지라면 사실상 항상 필요
export const JA_CRITICAL_FONT_SUBSET_URLS = [
  53, 60, 64, 76, 78, 105, 114, 115, 118,
].map(n => `${JA_FONT_BASE_URL}/woff2/PretendardJPVariable.subset.${n}.woff2`);
